import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default {
  state: {
    contract: '',
    contractSummaryMarkup: '',
    contractMarkup: '',
  },

  actions: {
    async GET_CONTRACT_MARKUP(context, payload) {
      const url = `/api/v4/public/contract/${payload}/latest`;
      const request = new Request(url, {
        method: 'GET',
        credentials: 'same-origin',
      });
      const response = await fetch(request);
      const markup = await response.text();
      context.commit('SET_CONTRACT_MARKUP', markup);
    },

    async GET_CONTRACT_SUMMARY_MARKUP(context, payload) {
      const url = `/api/v4/public/contract/${payload}/summary`;
      const request = new Request(url, {
        method: 'GET',
        credentials: 'same-origin',
      });
      const response = await fetch(request);
      const markup = await response.text();
      context.commit('SET_CONTRACT_SUMMARY_MARKUP', markup);
    },
  },

  mutations: {
    SET_CONTRACT_MARKUP(state, payload) {
      state.contractMarkup = payload;
    },
    SET_CONTRACT_SUMMARY_MARKUP(state, payload) {
      state.contractSummaryMarkup = payload;
    },
  },

  getters: {
    contractMarkup(state) {
      return state.contractMarkup;
    },
    contractSummaryMarkup(state) {
      return state.contractSummaryMarkup;
    },
  },
};
